export function veiculosdvecInRequest(params = {}) {
    return {
        type: '@dlgrelposto/DLGRELPOSTO_IN_REQUEST',
        payload: { params },
    };
}

export function failedRequest() {
    return {
        type: '@dlgrelposto/FAILED_REQUEST',
    };
}

export function successInRequest(
    dlgrelposto,
    page,
    pageSize,
    totalCount,
    totalPages
) {
    return {
        type: '@dlgrelposto/SUCCESS_IN_REQUEST',
        payload: { dlgrelposto, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(dlgrelposto) {
    return {
        type: '@dlgrelposto/SUCCESS_REQUEST',
        payload: { dlgrelposto },
    };
}

export function successRemove(params) {
    return {
        type: '@dlgrelposto/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@dlgrelposto/RECORD_FILTERING',
        payload: { params },
    };
}
